<template>
  <v-edit-dialog
    v-on="$listeners"
    :return-value.sync="theValue"
    @save="save"
    @cancel="cancel"
    @open="open"
    large
  >
    <v-btn text class="px-0">{{ price_formatted }}</v-btn>
    <template v-slot:input>
      <v-text-field
        v-model="theValue"
        label="Edit"
        single-line
        prefix="$"
        type="number"
      />
    </template>
  </v-edit-dialog>
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
import { Model } from '@vuex-orm/core'

export default {
  name: 'AdminCellDialogPrice',
  inject: {
    cancel: { default: null },
    open: { default: null },
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      theValue: (this.value / 100).toFixed(2),
      ValidationRules,
    }
  },
  methods: {
    save() {
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == this.theValue) return
        let timesAHundred = this.theValue * 100
        const fields = { [this.fieldName]: timesAHundred }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
  },
  computed: {
    price_formatted() {
      return this.Model.find(this.id).price_formatted
    },
  },
}
</script>
